import React, { useState, useRef, useEffect, useContext, useMemo } from "react";
import "../styles/HomePageMob.css";
import reg from "../assets/images/registration.png";
import rec from "../assets/images/receipt.png";
import redeem from "../assets/images/gift.png";
import backup from "../assets/images/backup.png";
import dash from "../assets/images/dashboard.png";
import exit from "../assets/images/exit.png";
import ss from "../assets/images/ssmobv.png";
import payonline from "../assets/images/payments/payment-method.webp";
import { useNavigate } from "react-router-dom";
import rclose from "../assets/images/findclose.png";
import io from "socket.io-client";
import SchemeRegistration from "../../src/components/Master/SchemeRegistration/SchemeRegistration";
import SchemeCashReceipt from "../components/Entry/SchemeReceipt/SchemeCashReceipt";
import SchemeRedeem from "../components/Entry/SchemeRedeem/SchemeRedeem";
import ledger from "../assets/images/ledger .png";

import SchemeReport from "../components/AccountReports/SchemeReports/SchemeReport";
import WindowHeader from "../components/Layout/WindowHeader/WindowHeader";
import ssLogo from "../assets/images/sslogo.png";
import minimize from "../assets/images/mini.png";
import maximize from "../assets/images/maximize.png";
import close from "../assets/images/findclose.png";
// import toggle from "../assets/images/MobToggle.png";
import toggle from "../assets/images/menus.png";

import toggleClose from "../assets/images/xred.webp";

import {
  FiFileText,
  FiBookOpen,
  FiUsers,
  FiGift,
  FiBarChart2,
  FiPower,
  FiFile,
  FiCreditCard,
} from "react-icons/fi";
import SherComboBox from "../components/ComboBoxes/SherComboBox";
import axios from "axios";
import LedgerReg from "../components/Master/AccountRegistration/LedgerRegistration/LedgerReg";
import StaffReg from "../components/Master/OtherRegistartion/StaffRegistration/StaffReg";
import zIndex from "@mui/material/styles/zIndex";
import Print from "../components/PrintModels/Print";
import { AuthContext } from "../context/AuthContext";
import { clearPrintTemplateCache } from "../hooks/usePrintService";
import Sidebar from "../components/Sidebar";
import { useDbContext } from "../context/DbContext";
import headeLogo from "../assets/images/shersoftnavLogo.png";
import { useSelector, useDispatch } from "react-redux";
import { selectMenuPermissions } from "../app/permissionsSlice";
import { fetchActiveFinancialYear, selectActiveFy, selectActiveFyid } from "../app/financialYearSlice";
import { useActiveFyLimits, parseDateToYyyyMmDd } from "../utils/fyDateValidation";
import { fetchActiveLocation, selectActiveLocation } from "../app/locationSlice";
function HomePageMob() {
  const navigate = useNavigate();
  const { logout, agentCode } = useContext(AuthContext);
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const permissions = useSelector(selectMenuPermissions);
  const activeFy = useSelector(selectActiveFy);
  const activeFyid = useSelector(selectActiveFyid);
  const activeLocation = useSelector(selectActiveLocation);
  const { minDate, maxDate, isDateInFy } = useActiveFyLimits();
  const [schemeReportPayload, setSchemeReportPayload] = useState(null);

  const { dbCode } = useDbContext();
  const dispatch = useDispatch();

  useEffect(() => {
    if (dbCode) {
      dispatch(fetchActiveFinancialYear(dbCode));
      dispatch(fetchActiveLocation(dbCode));
    }
  }, [dbCode, dispatch]);
  const [userType, setuserType] = useState("");
  const [userCode, setuserCode] = useState("");
  const [userAccno, setuserAccno] = useState("");
  //////////////console.log(userAccno, userCode);

  useEffect(() => {
    const storeduType = sessionStorage.getItem("userType");
    if (storeduType) {
      setuserType(storeduType);
      if (storeduType === "CUSTOMERS") {
        const customers = sessionStorage.getItem("CustomerName");
        const accno = sessionStorage.getItem("Uaccno");
        setuserCode(customers);
        setuserAccno(accno);
      }
    }
  }, []);
  const [companyName, setCompanyName] = useState("SherGold ERP");

  useEffect(() => {
    const fetchcompanydetails = async () => {
      if (!dbCode) return;
      try {
        const response = await axios.get(
          `${apiBaseUrl}/main/findCompanyDetails/${dbCode}`
        );
        const foundData = response.data?.[0];
        setCompanyName(foundData?.name || "SherGold ERP");
      } catch (error) {
        console.error("Error fetching company datas:", error.message);
      }
    };
    fetchcompanydetails();
  }, [apiBaseUrl, dbCode]);

  const [cRate, setCrate] = useState("");
  //////////////console.log(cRate);

  useEffect(() => {
    const fetchSchCurrentRate = async () => {
      try {
        const response = await axios.get(
          `${apiBaseUrl}/main/getGoldRate/${dbCode}`,
        );
        const currentrate = response.data[0]?.currentRate;
        setCrate(currentrate);
      } catch (error) {
        console.error("Error fetching gold rate:", error.message);
      }
    };

    fetchSchCurrentRate();
  }, [apiBaseUrl, dbCode]);

  const getCurrentDate = () => {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const day = String(currentDate.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  //////////agent name///////////////

  const [agentName, setagentName] = useState([]);
  const [agentobj, setAgentObj] = useState([]);
  const fetchAgname = async () => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/schsalesmanNames/${dbCode}`
      );

      // Assuming response.data is an array with objects and each object has a LedName property
      const AgName = response.data;

      // Transforming the array into the desired format
      // const supplName = cName.map((item) => item.LedName);

      const transformedData = AgName.map((item) => [item.Auto, item.Name]);
      setagentName(transformedData);

      // setsupplierName(supplName);
    } catch (error) {
      console.error("Error fetching agent Values:", error.message);
    }
  };

  useEffect(() => {
    const fetchAgname = async () => {
      try {
        const response = await axios.get(
          `${apiBaseUrl}/main/schsalesmanNames/${dbCode}`
        );

        // Assuming response.data is an array with objects and each object has a LedName property
        const AgName = response.data;

        // Transforming the array into the desired format
        // const supplName = cName.map((item) => item.LedName);

        const transformedData = AgName.map((item) => [item.Auto, item.Name]);
        setagentName(transformedData);

        // setsupplierName(supplName);
      } catch (error) {
        console.error("Error fetching agent Values:", error.message);
      }
    };

    fetchAgname();
  }, [apiBaseUrl]);

  const [ReportData, setReportData] = useState(() => {
    const today = new Date().toISOString().split("T")[0];
    const storeduType = sessionStorage.getItem("userType") || "";
    return {
      fromDate: storeduType === "CUSTOMERS" ? "2010-01-01" : today,
      toDate: today,
      reportType: "simpleReport",
      agent: { value: "", label: "" },
      customer: { value: "", label: "" },
      mobileNo: "",
      accno: { value: "", label: "" },
    };
  });

  const hasAlertedFyMobRef = useRef(false);
  useEffect(() => {
    if (activeFy && !hasAlertedFyMobRef.current) {
      const today = new Date().toISOString().split("T")[0];
      if (!isDateInFy(today)) {
        alert("Current date is outside the active financial year");
        hasAlertedFyMobRef.current = true;
      }
    }
  }, [activeFy, isDateInFy]);

  const handleClear = () => {
    const today = new Date().toISOString().split("T")[0];

    setReportData({
      fromDate: userType === "CUSTOMERS" ? "2010-01-01" : today,
      toDate: today,
      reportType: "simpleReport",
      agent: { value: "", label: "" },
      customer: { value: "", label: "" },
      mobileNo: "",
      accno: { value: "", label: "" },
    });
    setSchemeReportPayload(null);
    if (userType === "CUSTOMERS") {
      reportAgent();
    }
  };
  // //////////////////console.log("finddialogdata==", ReportData);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    setShowModal(true);
  }, []);

  const toggleModal = () => {
    setShowModal(!showModal);
  };

  const [showRegistrationModal, setShowRegistrationModal] = useState(false);
  const [showReceiptModal, setShowReceiptModal] = useState(false);
  const [showRedeemModal, setShowRedeemModal] = useState(false);
  const [showReportModal, setShowReportModal] = useState(false);
  const [showLedgerRegModal, setShowLedgerRegModal] = useState(false);

  const [showStaffRegModal, setShowStaffRegModal] = useState(false);

  const openRegistrationModal = () => {
    // if (isMobile) {
    //   navigate("/registration");
    // } else {
    setShowRegistrationModal(true);
    // }
  };
  const openLedgerRegModal = () => {
    // if (isMobile) {
    //   navigate("/registration");
    // } else {
    setShowLedgerRegModal(true);
    // }
  };

  const openStaffRegModal = () => {
    // if (isMobile) {
    //   navigate("/registration");
    // } else {
    setShowStaffRegModal(true);
    // }
  };
  const openReceiptModal = () => {
    // if (isMobile) {
    //   navigate("/receipt");
    // } else {
    setShowReceiptModal(true);
    // }
  };

  const openRedeemModal = () => {
    //     if(isMobile){
    // navigate("./redeem")
    //     }else{
    setShowRedeemModal(true);
    // }
  };

  const openReportModal = () => {
    // 1. Date validation against financial year (consistent with desktop SchemeReportDia)
    if (userType !== "CUSTOMERS" && ReportData.fromDate && !isDateInFy(ReportData.fromDate)) {
      alert("From Date incompatible with financial year");
      return;
    }
    if (ReportData.toDate && !isDateInFy(ReportData.toDate)) {
      alert("To Date incompatible with financial year");
      return;
    }

    // 2. Form IDs & summary text
    let selectedFormIds = [];
    if (userType === "CUSTOMERS") {
      selectedFormIds = allschemeforms.map((form) => form[0]);
    } else {
      selectedFormIds = selectedForms.length > 0 ? selectedForms : allschemeforms.map((form) => form[0]);
    }
    const selectedFormsText = allschemeforms
      .filter((form) => selectedFormIds.includes(form[0]))
      .map((form) => form[1])
      .join(", ");

    // 3. Customer resolution → numeric Ledcode (AND Ledcode = @customer)
    let customerFilterId = "";
    let customerNameStr = "";
    const selectedCustLabel = ReportData.customer?.label || (typeof ReportData.customer === "string" ? ReportData.customer : "");
    if (ReportData.customer?.value && !isNaN(Number(ReportData.customer.value))) {
      customerFilterId = String(ReportData.customer.value);
      customerNameStr = selectedCustLabel;
    } else if (selectedCustLabel && selectedCustLabel.trim()) {
      const q = selectedCustLabel.trim().toLowerCase();
      const match = RegcnameData.find(
        (c) =>
          ((c[1] || c.LedName) && String(c[1] || c.LedName).toLowerCase() === q) ||
          ((c[0] || c.accname) && String(c[0] || c.accname).toString() === q)
      );
      if (match) {
        customerFilterId = String(match[0] ?? match.accname);
        customerNameStr = String(match[1] ?? match.LedName);
      } else {
        customerNameStr = selectedCustLabel.trim();
      }
    }

    // 4. Agent resolution → numeric Auto ID (WHERE fmrAgentId = @agent)
    let agentFilterId = "";
    let agentNameStr = "";
    const selectedAgentLabel = ReportData.agent?.label || (typeof ReportData.agent === "string" ? ReportData.agent : "");
    if (ReportData.agent?.value && !isNaN(Number(ReportData.agent.value))) {
      agentFilterId = String(ReportData.agent.value);
      agentNameStr = selectedAgentLabel;
    } else if (selectedAgentLabel && selectedAgentLabel.trim()) {
      const q = selectedAgentLabel.trim().toLowerCase();
      const match = agentName.find(
        (a) =>
          ((a[1] || a.Name) && String(a[1] || a.Name).toLowerCase() === q) ||
          ((a[0] || a.Auto) && String(a[0] || a.Auto).toString() === q)
      );
      if (match) {
        agentFilterId = String(match[0] ?? match.Auto);
        agentNameStr = String(match[1] ?? match.Name);
      } else {
        agentNameStr = selectedAgentLabel.trim();
      }
    }

    // 5. Account No resolution → exact accno string (AND a.accno = @Ano)
    let accnoFilterStr = ReportData.accno?.label || (typeof ReportData.accno === "string" ? ReportData.accno : "") || ReportData.accno?.value || "";
    accnoFilterStr = accnoFilterStr.trim();
    if (!accnoFilterStr && userType === "CUSTOMERS" && userAccno) {
      accnoFilterStr = String(userAccno).trim();
    }

    const payload = {
      reportData: {
        fromDate: userType === "CUSTOMERS" ? "2010-01-01" : ReportData.fromDate,
        toDate: ReportData.toDate,
        reportType: ReportData.reportType || "simpleReport",
        customer: customerFilterId,
        customerName: customerNameStr,
        agent: agentFilterId,
        agentName: agentNameStr,
        accno: accnoFilterStr,
        mobileNo: userType === "CUSTOMERS" ? "" : (ReportData.mobileNo || ""),
        selectedFormsText,
        fyid: activeFyid || activeFy?.fyid || 0,
        locationId: activeLocation?.id ? Number(activeLocation.id) : 0,
        locationName: activeLocation?.name || "All Locations",
      },
      forms: selectedFormIds,
    };

    setSchemeReportPayload(payload);
    setShowFindDialog(false);
    setShowReportModal(true);
  };

  const openReportPage = () => {
    navigate("/report"); // Navigate to the report page
  };

  const [showFindDialog, setShowFindDialog] = useState(false); // State for controlling the visibility of the find dialog
  const [findEntryNo, setFindEntryNo] = useState(""); // State to store the entry number entered in the find dialog
  // //////////////////console.log(findEntryNo);
  const openFindDialog = () => {
    setShowFindDialog(true);
    fetchAccno();
    fetchAgname();
    fetchRegCname();
  };

  ////////////////////console.log(ReportData);
  const reportAgent = () => {
    if (userType === "CUSTOMERS") {
      const match = accNo.find((item) => (item[1] || item.accno) === userAccno);
      setReportData((prev) => ({
        ...prev,
        accno: match
          ? { value: match[0] ?? match.auto, label: match[1] ?? match.accno }
          : { value: "", label: userAccno || "" },
      }));
    } else if (userType !== "ADMIN" && agentCode) {
      const match = agentName.find((item) => (item[0] ?? item.Auto) === parseInt(agentCode));
      setReportData((prev) => ({
        ...prev,
        agent: match
          ? { value: match[0] ?? match.Auto, label: match[1] ?? match.Name }
          : { value: "", label: "" },
        accno: { value: "", label: "" },
      }));
    }
  };

  const closeFindDialog = (e) => {
    handleClear(e);
    setShowFindDialog(false);
    setFindEntryNo("");
  };

  const isMobile = window.innerWidth <= 768;

  const customerRef = useRef(null);
  const agentRef = useRef(null);
  const pNoRef = useRef(null);
  const accRef = useRef(null);

  const [RegcnameData, setRegCnameData] = useState([]);
  const fetchRegCname = async () => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/SchRec_schemeregisteredcustomers/${dbCode}`
      );

      // Assuming response.data is an array with objects and each object has a LedName property
      const cName = response.data;

      // Transforming the array into the desired format
      // const supplName = cName.map((item) => item.LedName);

      const transformedData = cName.map((item) => [item.accname, item.LedName]);
      setRegCnameData(transformedData);

      // setsupplierName(supplName);
    } catch (error) {
      console.error("Error fetching regcustomers Values:", error.message);
    }
  };
  useEffect(() => {
    const fetchRegCname = async () => {
      try {
        const response = await axios.get(
          `${apiBaseUrl}/main/SchRec_schemeregisteredcustomers/${dbCode}`
        );

        // Assuming response.data is an array with objects and each object has a LedName property
        const cName = response.data;

        // Transforming the array into the desired format
        // const supplName = cName.map((item) => item.LedName);

        const transformedData = cName.map((item) => [
          item.accname,
          item.LedName,
        ]);
        setRegCnameData(transformedData);

        // setsupplierName(supplName);
      } catch (error) {
        console.error("Error fetching regcustomers Values:", error.message);
      }
    };

    fetchRegCname();
  }, [apiBaseUrl]);

  const [accNo, setaccNo] = useState([]);
  // //////////////////console.log('......',accnoAuto);
  const fetchAccno = async () => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/SchRec_Accno/${dbCode}`
      );

      // Assuming response.data is an array with objects and each object has a LedName property
      const Accno = response.data;

      // Transforming the array into the desired format
      // const supplName = cName.map((item) => item.LedName);

      const transformedData = Accno.map((item) => [item.auto, item.accno]);
      setaccNo(transformedData);

      // setsupplierName(supplName);
    } catch (error) {
      console.error("Error fetching accno Values:", error.message);
    }
  };

  useEffect(() => {
    const fetchAccno = async () => {
      try {
        const response = await axios.get(
          `${apiBaseUrl}/main/SchRec_Accno/${dbCode}`
        );

        // Assuming response.data is an array with objects and each object has a LedName property
        const Accno = response.data;

        // Transforming the array into the desired format
        // const supplName = cName.map((item) => item.LedName);

        const transformedData = Accno.map((item) => [item.auto, item.accno]);
        setaccNo(transformedData);

        // setsupplierName(supplName);
      } catch (error) {
        console.error("Error fetching accno Values:", error.message);
      }
    };

    fetchAccno();
  }, [apiBaseUrl]);

  useEffect(() => {
    // Push a new state to the history stack when the component mounts
    window.history.pushState(null, null, window.location.pathname);

    // Add a listener to the 'popstate' event
    window.addEventListener("popstate", handlePopstate);

    // Clean up the listener when the component unmounts
    return () => {
      window.removeEventListener("popstate", handlePopstate);
    };
  }, []);

  const handlePopstate = () => {
    // Push another state to the history stack, effectively preventing the user from going back
    window.history.pushState(null, null, window.location.pathname);
  };

  const schemeRegistrationRef = useRef(null);

  const handleClearInSchemeReg = () => {
    if (schemeRegistrationRef.current) {
      schemeRegistrationRef.current.handleClear();
    }
  };
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  ///////////////////////////////////////////////////////////////

  const [showRecOptions, setShowRecOptions] = useState(false); // State for controlling the visibility of the find dialog
  const [showRedeemOptions, setShowRedeemOptions] = useState(false);

  const openRecOptions = () => {
    setShowRecOptions(true);
  };

  const closeRecOptions = () => {
    setShowRecOptions(false);
  };

  const openRedeemOptions = () => {
    setShowRedeemOptions(true);
  };

  const closeRedeemOptions = () => {
    setShowRedeemOptions(false);
  };

  const [formsByagent, setformsByagent] = useState([]);
  const [redeemFormsByagent, setRedeemFormsByagent] = useState([]);

  useEffect(() => {
    const fetchFormsByAgent = async () => {
      try {
        const response = await axios.get(
          `${apiBaseUrl}/common/selectfrmDatasByagent/${parseInt(
            agentCode
          )}/${dbCode}`
        );

        const formDatas = response.data || [];
        const RecData = formDatas
          .filter(
            (item) =>
              item.fmrTypeOfVoucher === "SCHEME RECEIPT" ||
              item.fmrTypeOfVoucher === "Scheme Receipt Order",
          )
          .map((item) => [item.fmrEntryNo, item.fmrAbbreviation, item.fmrTypeOfVoucher]);
        setformsByagent(RecData);

        const RedeemData = formDatas
          .filter((item) => item.fmrTypeOfVoucher === "SCHEME REDEEM")
          .map((item) => [item.fmrEntryNo, item.fmrAbbreviation, item.fmrTypeOfVoucher]);
        setRedeemFormsByagent(RedeemData);
      } catch (error) {
        console.error("Error fetching form  Values:", error.message);
      }
    };

    if (agentCode) {
      fetchFormsByAgent();
    }
  }, [apiBaseUrl, userType, agentCode]);

  const [allReceipts, setallReceipts] = useState([]);
  const [allschemeforms, setallschemeforms] = useState([]);

  // ----------------------------------Receipt Vouchers------------------------------------

  const [allVocherReceipts, setallVoucherReceipts] = useState([]);

  // ----------------------------------Payment Vouchers------------------------------------
  const [allVocherPayments, setallVoucherPayments] = useState([]);

  // ----------------------------------purchase Entry Options------------------------------------

  const [allPurchaseforms, setallPurchaseforms] = useState([]);

  // ----------------------------------Fetch FormDatas------------------------------------

  const fetchAllformDatas = async () => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/common/selectAllformDatas/${dbCode}`
      );

      const Res = response.data;
      ////////////console.log("Rec", response.data);

      // Transforming the array into the desired format

      const purchaseData = Res.filter(
        (item) => item.fmrTypeOfVoucher === "PURCHASE"
      ) // Filtering condition
        .map((item) => [item.fmrEntryNo, item.fmrName]);

      // //////////console.log("transformedData==",transformedData);

      setallPurchaseforms(purchaseData);

      const RecData = Res.filter(
        (item) =>
          item.fmrTypeOfVoucher === "SCHEME RECEIPT" ||
          item.fmrTypeOfVoucher === "SCHEME REDEEM"
      ).map((item) => [item.fmrEntryNo, item.fmrAbbreviation]);

      setallReceipts(RecData);

      const Data = Res.filter(
        (item) =>
          item.fmrTypeOfVoucher === "SCHEME RECEIPT" ||
          item.fmrTypeOfVoucher === "SCHEME REDEEM"
      ).map((item) => [item.fmrEntryNo, item.fmrAbbreviation]);

      setallschemeforms(Data);

      const voucherRecData = Res.filter(
        (item) => item.fmrTypeOfVoucher === "RECEIPT"
      ).map((item) => [item.fmrEntryNo, item.fmrName]);

      // //////////console.log("transformedData==",transformedData);

      setallVoucherReceipts(voucherRecData);

      const voucherPayData = Res.filter(
        (item) => item.fmrTypeOfVoucher === "PAYMENT"
      ).map((item) => [item.fmrEntryNo, item.fmrName]);

      // //////////console.log("transformedData==",transformedData);

      setallVoucherPayments(voucherPayData);
    } catch (error) {
      console.error("Error fetching Purchase forms Values:", error.message);
    }
    // ////////////console.log("asss", setallVoucherReceipts);
  };
  useEffect(() => {
    fetchAllformDatas();
  }, [apiBaseUrl]);

  // ----------------------------------Websockets for forms------------------------------------

  useEffect(() => {
    const socket = io(apiBaseUrl); // Make sure the URL matches your backend server
    socket.on("formUpdated", () => {
      fetchAllformDatas();
    });
    socket.on("printTemplateUpdated", (data) => {
      clearPrintTemplateCache();
      window.dispatchEvent(new CustomEvent("printTemplateUpdated", { detail: data }));
    });

    return () => {
      socket.disconnect();
    };
  }, [apiBaseUrl]);

  ////////////////////////////////dialogue box////////////////////
  const [selectedForms, setSelectedForms] = useState([]);
  ////////console.log("selectedForms==", selectedForms);

  const toggleFormSelection = (frmId) => {
    setSelectedForms((prevSelected) =>
      prevSelected.includes(frmId)
        ? prevSelected.filter((id) => id !== frmId)
        : [...prevSelected, frmId]
    );
  };

  const selectAll = () => {
    const allFormIds = allschemeforms.map((form) => form[0]);
    setSelectedForms(allFormIds);
  };

  useEffect(() => {
    if (userType === "CUSTOMERS") {
      selectAll();
      setReportData((prev) => ({
        ...prev,
        fromDate: "2010-01-01",
      }));
    }
  }, [userType, formsByagent, allschemeforms]);

  const unSelectAll = () => {
    setSelectedForms([]);
  };



  // Derived options for SherComboBox
  const customerOpts = useMemo(() => {
    return RegcnameData.map((item) => ({
      label: item[1] || item.LedName || "",
      value: item[0] ?? item.accname ?? ""
    }));
  }, [RegcnameData]);

  const agentOpts = useMemo(() => {
    return agentName.map((item) => ({
      label: item[1] || item.Name || "",
      value: item[0] ?? item.Auto ?? ""
    }));
  }, [agentName]);

  const accNoOpts = useMemo(() => {
    const seen = new Set();
    const list = [];
    (accNo || []).forEach((item) => {
      const numStr = String((Array.isArray(item) ? item[1] : (item.accno ?? "")) ?? "").trim();
      if (numStr && !seen.has(numStr)) {
        seen.add(numStr);
        list.push({ label: numStr, value: numStr });
      }
    });
    return list;
  }, [accNo]);

  const handleExit = () => {

    const storedDbCode = localStorage.getItem("dbCode");
    if (!storedDbCode) {
      navigate("/");
    } else {
      navigate("/login");
    }

  };
  return (
    <div className="HomePageMobroot min-h-screen w-full relative flex flex-col justify-between overflow-x-hidden font-Inter">
      {/* ── TOP: SherGold Branding + Tagline ── */}
      <div className="w-full pt-5 pb-2 px-5 flex flex-col items-start z-10 shrink-0">
        <div className="flex items-center text-white text-[24px] sm:text-[28px] font-semibold tracking-tight leading-none font-Inter">
          SherGold
          <span className="ml-2 erp-gold-sloped-shape text-[12px] sm:text-[13px]">
            <span className="erp-gold-sloped-inner">
              <span className="erp-gold-sloped-text">ERP</span>
            </span>
          </span>
        </div>
        <p className="text-blue-100/90 text-[11px] sm:text-[12px] leading-snug italic font-semibold mt-1 font-Inter">
          A Complete Accounting & Inventory Package
        </p>
      </div>

      {/* ── CENTER: Company Name + Action Buttons Grid ── */}
      <div className="flex-1 w-full flex flex-col items-center justify-center px-4 py-3 z-10 max-w-md mx-auto">
        <div className="text-white text-[15.5px] sm:text-[17.5px] font-semibold tracking-wide text-center uppercase font-Inter -mt-6 sm:-mt-8 mb-5 sm:mb-6 drop-shadow-md">
          {companyName}
        </div>

        <div className="grid grid-cols-2 gap-3.5 sm:gap-4 w-full max-w-[320px] sm:max-w-[360px]">
          {permissions["schemeReg"]?.visible && userType !== "CUSTOMERS" && (
            <button
              className="group home-action-btn w-full h-[95px] sm:h-[105px] px-2 text-center bg-blue-500/20 hover:bg-blue-500/35 active:bg-blue-500/40 border border-white/25 hover:border-white/50 backdrop-blur-md rounded-xl flex flex-col items-center justify-center text-white transition-all duration-300 shadow-lg shadow-black/20 hover:-translate-y-1 active:scale-95"
              onClick={() => navigate("/registration")}
            >
              <div className="home-action-icon w-10 h-10 sm:w-11 sm:h-11 rounded-full border border-white/40 flex items-center justify-center mb-1.5 bg-white/15 backdrop-blur-sm shadow-inner shadow-white/20 transition-all duration-300 group-hover:scale-110 group-hover:border-white/80 group-hover:bg-white/25 group-hover:shadow-[0_0_16px_rgba(255,255,255,0.4)]">
                <FiFileText className="text-xl sm:text-2xl text-white drop-shadow-sm transition-transform duration-300 group-hover:scale-105" />
              </div>
              <span className="font-medium text-xs sm:text-[13px] tracking-wide text-white/95 group-hover:text-white drop-shadow-sm font-Inter">
                Registration
              </span>
            </button>
          )}

          {permissions["schemecashReceipt"]?.visible && userType !== "CUSTOMERS" && (
            <button
              className="group home-action-btn w-full h-[95px] sm:h-[105px] px-2 text-center bg-blue-500/20 hover:bg-blue-500/35 active:bg-blue-500/40 border border-white/25 hover:border-white/50 backdrop-blur-md rounded-xl flex flex-col items-center justify-center text-white transition-all duration-300 shadow-lg shadow-black/20 hover:-translate-y-1 active:scale-95 disabled:opacity-40 disabled:cursor-not-allowed"
              onClick={() => openRecOptions()}
              disabled={userType === "CUSTOMERS"}
            >
              <div className="home-action-icon w-10 h-10 sm:w-11 sm:h-11 rounded-full border border-white/40 flex items-center justify-center mb-1.5 bg-white/15 backdrop-blur-sm shadow-inner shadow-white/20 transition-all duration-300 group-hover:scale-110 group-hover:border-white/80 group-hover:bg-white/25 group-hover:shadow-[0_0_16px_rgba(255,255,255,0.4)]">
                <div className="relative flex items-center justify-center transition-transform duration-300 group-hover:scale-105">
                  <FiFile className="text-xl sm:text-2xl text-white drop-shadow-sm" />
                  <span className="absolute text-[8px] font-bold text-white mt-[2px]">
                    $
                  </span>
                </div>
              </div>
              <span className="font-medium text-xs sm:text-[13px] tracking-wide text-white/95 group-hover:text-white drop-shadow-sm font-Inter">
                Cash Receipt
              </span>
            </button>
          )}

          {permissions["schemeRedeem"]?.visible && userType !== "CUSTOMERS" && (
            <button
              className="group home-action-btn w-full h-[95px] sm:h-[105px] px-2 text-center bg-blue-500/20 hover:bg-blue-500/35 active:bg-blue-500/40 border border-white/25 hover:border-white/50 backdrop-blur-md rounded-xl flex flex-col items-center justify-center text-white transition-all duration-300 shadow-lg shadow-black/20 hover:-translate-y-1 active:scale-95"
              onClick={() => openRedeemOptions()}
            >
              <div className="home-action-icon w-10 h-10 sm:w-11 sm:h-11 rounded-full border border-white/40 flex items-center justify-center mb-1.5 bg-white/15 backdrop-blur-sm shadow-inner shadow-white/20 transition-all duration-300 group-hover:scale-110 group-hover:border-white/80 group-hover:bg-white/25 group-hover:shadow-[0_0_16px_rgba(255,255,255,0.4)]">
                <FiGift className="text-xl sm:text-2xl text-white drop-shadow-sm transition-transform duration-300 group-hover:scale-105" />
              </div>
              <span className="font-medium text-xs sm:text-[13px] tracking-wide text-white/95 group-hover:text-white drop-shadow-sm font-Inter">
                Redeem
              </span>
            </button>
          )}

          {permissions["ledgerReg"]?.visible && userType !== "CUSTOMERS" && (
            <button
              className="group home-action-btn w-full h-[95px] sm:h-[105px] px-2 text-center bg-blue-500/20 hover:bg-blue-500/35 active:bg-blue-500/40 border border-white/25 hover:border-white/50 backdrop-blur-md rounded-xl flex flex-col items-center justify-center text-white transition-all duration-300 shadow-lg shadow-black/20 hover:-translate-y-1 active:scale-95"
              onClick={() => navigate("/ledmob")}
            >
              <div className="home-action-icon w-10 h-10 sm:w-11 sm:h-11 rounded-full border border-white/40 flex items-center justify-center mb-1.5 bg-white/15 backdrop-blur-sm shadow-inner shadow-white/20 transition-all duration-300 group-hover:scale-110 group-hover:border-white/80 group-hover:bg-white/25 group-hover:shadow-[0_0_16px_rgba(255,255,255,0.4)]">
                <FiBookOpen className="text-xl sm:text-2xl text-white drop-shadow-sm transition-transform duration-300 group-hover:scale-105" />
              </div>
              <span className="font-medium text-xs sm:text-[13px] tracking-wide text-white/95 group-hover:text-white drop-shadow-sm font-Inter">
                Ledger Reg
              </span>
            </button>
          )}

          {permissions["employeeReg"]?.visible && userType !== "CUSTOMERS" && (
            <button
              className="group home-action-btn w-full h-[95px] sm:h-[105px] px-2 text-center bg-blue-500/20 hover:bg-blue-500/35 active:bg-blue-500/40 border border-white/25 hover:border-white/50 backdrop-blur-md rounded-xl flex flex-col items-center justify-center text-white transition-all duration-300 shadow-lg shadow-black/20 hover:-translate-y-1 active:scale-95 disabled:opacity-40 disabled:cursor-not-allowed"
              onClick={() => navigate("/staffregmob")}
              disabled={userType !== "ADMIN"}
            >
              <div className="home-action-icon w-10 h-10 sm:w-11 sm:h-11 rounded-full border border-white/40 flex items-center justify-center mb-1.5 bg-white/15 backdrop-blur-sm shadow-inner shadow-white/20 transition-all duration-300 group-hover:scale-110 group-hover:border-white/80 group-hover:bg-white/25 group-hover:shadow-[0_0_16px_rgba(255,255,255,0.4)]">
                <FiUsers className="text-xl sm:text-2xl text-white drop-shadow-sm transition-transform duration-300 group-hover:scale-105" />
              </div>
              <span className="font-medium text-xs sm:text-[13px] tracking-wide text-white/95 group-hover:text-white drop-shadow-sm font-Inter">
                Staff Reg
              </span>
            </button>
          )}

          {permissions["schemeReport"]?.visible && (
            <button
              className="group home-action-btn w-full h-[95px] sm:h-[105px] px-2 text-center bg-blue-500/20 hover:bg-blue-500/35 active:bg-blue-500/40 border border-white/25 hover:border-white/50 backdrop-blur-md rounded-xl flex flex-col items-center justify-center text-white transition-all duration-300 shadow-lg shadow-black/20 hover:-translate-y-1 active:scale-95"
              onClick={(e) => {
                openFindDialog(e);
                reportAgent(e);
              }}
            >
              <div className="home-action-icon w-10 h-10 sm:w-11 sm:h-11 rounded-full border border-white/40 flex items-center justify-center mb-1.5 bg-white/15 backdrop-blur-sm shadow-inner shadow-white/20 transition-all duration-300 group-hover:scale-110 group-hover:border-white/80 group-hover:bg-white/25 group-hover:shadow-[0_0_16px_rgba(255,255,255,0.4)]">
                <FiBarChart2 className="text-xl sm:text-2xl text-white drop-shadow-sm transition-transform duration-300 group-hover:scale-105" />
              </div>
              <span className="font-medium text-xs sm:text-[13px] tracking-wide text-white/95 group-hover:text-white drop-shadow-sm font-Inter">
                Scheme Report
              </span>
            </button>
          )}

          {permissions["upipayment"]?.visible && userType === "CUSTOMERS" && (
            <button
              className="group home-action-btn w-full h-[95px] sm:h-[105px] px-2 text-center bg-blue-500/20 hover:bg-blue-500/35 active:bg-blue-500/40 border border-white/25 hover:border-white/50 backdrop-blur-md rounded-xl flex flex-col items-center justify-center text-white transition-all duration-300 shadow-lg shadow-black/20 hover:-translate-y-1 active:scale-95"
              onClick={() => navigate("/upipayment")}
            >
              <div className="home-action-icon w-10 h-10 sm:w-11 sm:h-11 rounded-full border border-white/40 flex items-center justify-center mb-1.5 bg-white/15 backdrop-blur-sm shadow-inner shadow-white/20 transition-all duration-300 group-hover:scale-110 group-hover:border-white/80 group-hover:bg-white/25 group-hover:shadow-[0_0_16px_rgba(255,255,255,0.4)]">
                <FiCreditCard className="text-xl sm:text-2xl text-white drop-shadow-sm transition-transform duration-300 group-hover:scale-105" />
              </div>
              <span className="font-medium text-xs sm:text-[13px] tracking-wide text-white/95 group-hover:text-white drop-shadow-sm font-Inter">
                Pay Online
              </span>
            </button>
          )}

          <button
            className="group home-action-btn w-full h-[95px] sm:h-[105px] px-2 text-center bg-blue-500/20 hover:bg-blue-500/35 active:bg-blue-500/40 border border-white/25 hover:border-white/50 backdrop-blur-md rounded-xl flex flex-col items-center justify-center text-white transition-all duration-300 shadow-lg shadow-black/20 hover:-translate-y-1 active:scale-95"
            onClick={handleExit}
          >
            <div className="home-action-icon w-10 h-10 sm:w-11 sm:h-11 rounded-full border border-white/40 flex items-center justify-center mb-1.5 bg-white/15 backdrop-blur-sm shadow-inner shadow-white/20 transition-all duration-300 group-hover:scale-110 group-hover:border-white/80 group-hover:bg-white/25 group-hover:shadow-[0_0_16px_rgba(255,255,255,0.4)]">
              <FiPower className="text-xl sm:text-2xl text-white drop-shadow-sm transition-transform duration-300 group-hover:scale-105" />
            </div>
            <span className="font-medium text-xs sm:text-[13px] tracking-wide text-white/95 group-hover:text-white drop-shadow-sm font-Inter">
              Exit
            </span>
          </button>
        </div>
      </div>

      {/* ── BOTTOM: SherSoft Company Info ── */}
      <div className="w-full pb-4 pt-2 px-5 flex items-center justify-start gap-3.5 z-10 shrink-0">
        <img
          src={ss}
          alt="SherSoft"
          className="h-12 sm:h-14 w-auto object-contain shrink-0 drop-shadow-md"
        />
        <div className="text-[11px] sm:text-[11.5px] leading-snug">
          <div className="font-extrabold text-white text-[13.5px] sm:text-[14.5px] mb-0.5 tracking-tight font-Inter">
            SherSoft
          </div>
          <div className="text-white/85 font-medium font-Inter">Software Company</div>
          <div className="text-white/85 font-medium font-Inter">www.shersoftware.com</div>
          <div className="text-white/85 font-medium font-Inter">PH: 9847997755</div>
          <div className="text-white/85 font-medium font-Inter">Email: shersoftware@gmail.com</div>
        </div>
      </div>

      {showFindDialog && (
        <div
          className="fixed inset-0 flex items-center justify-center p-2.5 sm:p-4 z-[10000]"
          style={{ background: "rgba(0,0,0,0.5)", backdropFilter: "blur(3px)" }}
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              closeFindDialog(e);
              handleClear();
            }
          }}
        >
          <div
            className="bg-white rounded-lg shadow-2xl flex flex-col overflow-hidden border border-slate-300 w-full max-w-[560px] max-h-[90vh]"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Window Header */}
            <WindowHeader
              title="Scheme Report"
              logo={headeLogo}
              onClose={(e) => {
                closeFindDialog(e);
                handleClear();
              }}
              className="bg-[#0f56d3] h-[42px] text-white font-Inter"
              titleClassName="text-[13px] font-semibold"
              closeBtnClassName="w-7 h-7 rounded-[5px] border-none mr-2 flex items-center justify-center"
            />

            {/* Body */}
            <div className="flex flex-col sm:flex-row flex-1 overflow-hidden min-h-0 bg-white">
              {/* Left panel: Forms list (Only for non-CUSTOMERS) */}
              {userType !== "CUSTOMERS" && (
                <div className="flex flex-col border-b sm:border-b-0 sm:border-r border-gray-200 w-full sm:w-[170px] shrink-0 bg-[#fbfcfe]">
                  <div className="px-2.5 py-1.5 text-[11px] font-semibold text-slate-800 font-Inter bg-[#eef2f9] border-b border-gray-200">
                    Select Scheme Form
                  </div>
                  <div className="flex-1 overflow-y-auto max-h-[140px] sm:max-h-[300px] bg-white divide-y divide-gray-100">
                    {allschemeforms.map(([frmId, abbreviation]) => (
                      <label
                        key={frmId}
                        className={`flex items-center gap-2 px-2.5 py-1.5 cursor-pointer select-none text-[11px] font-Inter font-medium transition-colors ${
                          selectedForms.includes(frmId)
                            ? "bg-[#dbeafe] text-[#1e40af]"
                            : "bg-white text-slate-700 hover:bg-slate-50"
                        }`}
                      >
                        <input
                          type="checkbox"
                          checked={selectedForms.includes(frmId)}
                          onChange={() => toggleFormSelection(frmId)}
                          className="w-3.5 h-3.5 rounded border-gray-300 accent-[#1a56db] shrink-0 cursor-pointer"
                        />
                        <span className="truncate">{abbreviation}</span>
                      </label>
                    ))}
                  </div>
                  <div className="flex gap-1.5 p-1.5 border-t border-gray-200 bg-[#f8fafc]">
                    <button
                      type="button"
                      onClick={selectAll}
                      className="flex-1 py-1 px-1 border border-gray-300 rounded-[4px] bg-white hover:bg-gray-100 text-[10px] text-slate-700 font-semibold cursor-pointer font-Inter"
                    >
                      Select All
                    </button>
                    <button
                      type="button"
                      onClick={unSelectAll}
                      className="flex-1 py-1 px-1 border border-gray-300 rounded-[4px] bg-white hover:bg-gray-100 text-[10px] text-slate-700 font-semibold cursor-pointer font-Inter"
                    >
                      UnSelect All
                    </button>
                  </div>
                </div>
              )}

              {/* Right panel: Filter inputs */}
              <div className="flex flex-col flex-1 overflow-hidden min-w-0">
                <div className="flex-1 overflow-y-auto p-3 sm:p-4 flex flex-col gap-2.5 font-Inter">
                  {/* Dates */}
                  <div className="flex items-center gap-2">
                    <span className="text-[11px] font-medium text-slate-600 font-Inter w-[85px] shrink-0">
                      From Date
                    </span>
                    <input
                      type="date"
                      min={minDate}
                      max={maxDate}
                      value={userType === "CUSTOMERS" ? "2010-01-01" : ReportData.fromDate}
                      onChange={(e) => {
                        if (userType !== "CUSTOMERS") {
                          setReportData((prev) => ({
                            ...prev,
                            fromDate: e.target.value,
                          }));
                        }
                      }}
                      onBlur={(e) => {
                        if (userType !== "CUSTOMERS") {
                          const val = e.target.value;
                          if (val && !isDateInFy(val)) {
                            alert("Date incompatible with financial year");
                          }
                        }
                      }}
                      disabled={userType === "CUSTOMERS"}
                      className="flex-1 border border-gray-300 rounded-[4px] h-7 px-2 text-[11px] text-slate-800 font-Inter focus:outline-none focus:border-[#1a3abf] disabled:bg-gray-100"
                    />
                  </div>

                  <div className="flex items-center gap-2">
                    <span className="text-[11px] font-medium text-slate-600 font-Inter w-[85px] shrink-0">
                      To Date
                    </span>
                    <input
                      type="date"
                      min={minDate}
                      max={maxDate}
                      value={ReportData.toDate}
                      onChange={(e) =>
                        setReportData((prev) => ({
                          ...prev,
                          toDate: e.target.value,
                        }))
                      }
                      onBlur={(e) => {
                        const val = e.target.value;
                        if (val && !isDateInFy(val)) {
                          alert("Date incompatible with financial year");
                        }
                      }}
                      className="flex-1 border border-gray-300 rounded-[4px] h-7 px-2 text-[11px] text-slate-800 font-Inter focus:outline-none focus:border-[#1a3abf]"
                    />
                  </div>

                  {/* Rate row for CUSTOMERS */}
                  {userType === "CUSTOMERS" && (
                    <div className="flex items-center gap-2">
                      <span className="text-[11px] font-medium text-slate-600 font-Inter w-[85px] shrink-0">
                        Rate
                      </span>
                      <input
                        type="text"
                        readOnly
                        value={cRate}
                        className="flex-1 border border-gray-300 rounded-[4px] h-7 px-2 text-[11px] text-slate-800 font-Inter bg-gray-100"
                      />
                    </div>
                  )}

                  {/* Report Type */}
                  <div className="flex items-center gap-2">
                    <span className="text-[11px] font-medium text-slate-600 font-Inter w-[85px] shrink-0">
                      Report Type
                    </span>
                    <select
                      value={ReportData.reportType}
                      onChange={(e) =>
                        setReportData({
                          ...ReportData,
                          reportType: e.target.value,
                        })
                      }
                      className="flex-1 border border-gray-300 rounded-[4px] h-7 px-2 text-[11px] text-slate-800 font-Inter bg-white focus:outline-none focus:border-[#1a3abf]"
                    >
                      <option value="simpleReport">Simple</option>
                      <option value="reportOrderbyEntryno">Order By EntryNo</option>
                      <option value="cabaReport">CASH/BANK Report</option>
                      <option value="closedAccountsReport">Closed Account Reports</option>
                      <option value="closedAccounts">Closed Accounts</option>
                    </select>
                  </div>

                  {/* Scheme Customer Dropdown */}
                  <div className="flex items-center gap-2">
                    <span className="text-[11px] font-medium text-slate-600 font-Inter w-[85px] shrink-0">
                      Customer
                    </span>
                    <div className="flex-1 min-w-0">
                      <SherComboBox
                        options={customerOpts}
                        value={ReportData.customer?.label || (typeof ReportData.customer === "string" ? ReportData.customer : "")}
                        onSelect={(opt) =>
                          setReportData((prev) => ({
                            ...prev,
                            customer: opt || { value: "", label: "" },
                          }))
                        }
                        onInputChange={(text) => {
                          setReportData((prev) => ({
                            ...prev,
                            customer: text === ""
                              ? { value: "", label: "" }
                              : (text !== prev.customer?.label ? { value: text, label: text } : prev.customer),
                          }));
                        }}
                        onClear={() =>
                          setReportData((prev) => ({
                            ...prev,
                            customer: { value: "", label: "" },
                          }))
                        }
                        readOnly={userType !== "ADMIN"}
                        inputClassName="w-full border border-gray-300 rounded-[4px] font-Inter disabled:bg-gray-100 text-[11px]"
                        inputStyle={{ fontFamily: "Inter, sans-serif" }}
                        inputHeight="28px"
                      />
                    </div>
                  </div>

                  {/* Scheme Agent Dropdown (only when userType !== "CUSTOMERS") */}
                  {userType !== "CUSTOMERS" && (
                    <div className="flex items-center gap-2">
                      <span className="text-[11px] font-medium text-slate-600 font-Inter w-[85px] shrink-0">
                        Agent
                      </span>
                      <div className="flex-1 min-w-0">
                        <SherComboBox
                          options={agentOpts}
                          value={ReportData.agent?.label || (typeof ReportData.agent === "string" ? ReportData.agent : "")}
                          onSelect={(opt) =>
                            setReportData((prev) => ({
                              ...prev,
                              agent: opt || { value: "", label: "" },
                            }))
                          }
                          onInputChange={(text) => {
                            setReportData((prev) => ({
                              ...prev,
                              agent: text === ""
                                ? { value: "", label: "" }
                                : (text !== prev.agent?.label ? { value: text, label: text } : prev.agent),
                            }));
                          }}
                          onClear={() =>
                            setReportData((prev) => ({
                              ...prev,
                              agent: { value: "", label: "" },
                            }))
                          }
                          readOnly={userType !== "ADMIN"}
                          inputClassName="w-full border border-gray-300 rounded-[4px] font-Inter disabled:bg-gray-100 text-[11px]"
                          inputStyle={{ fontFamily: "Inter, sans-serif" }}
                          inputHeight="28px"
                        />
                      </div>
                    </div>
                  )}

                  {/* Account Number Dropdown */}
                  <div className="flex items-center gap-2">
                    <span className="text-[11px] font-medium text-slate-600 font-Inter w-[85px] shrink-0">
                      Account No
                    </span>
                    <div className="flex-1 min-w-0">
                      <SherComboBox
                        options={accNoOpts}
                        value={ReportData.accno?.label || (typeof ReportData.accno === "string" ? ReportData.accno : "")}
                        onSelect={(opt) =>
                          setReportData((prev) => ({
                            ...prev,
                            accno: opt || { value: "", label: "" },
                          }))
                        }
                        onInputChange={(text) => {
                          setReportData((prev) => ({
                            ...prev,
                            accno: { value: text, label: text },
                          }));
                        }}
                        onFreeInput={(text) => {
                          setReportData((prev) => ({
                            ...prev,
                            accno: { value: text, label: text },
                          }));
                        }}
                        onClear={() =>
                          setReportData((prev) => ({
                            ...prev,
                            accno: { value: "", label: "" },
                          }))
                        }
                        readOnly={userType === "CUSTOMERS"}
                        inputClassName="w-full border border-gray-300 rounded-[4px] font-Inter disabled:bg-gray-100 text-[11px]"
                        inputStyle={{ fontFamily: "Inter, sans-serif" }}
                        inputHeight="28px"
                      />
                    </div>
                  </div>

                  {/* Phone Number Input (only when userType !== "CUSTOMERS") */}
                  {userType !== "CUSTOMERS" && (
                    <div className="flex items-center gap-2">
                      <span className="text-[11px] font-medium text-slate-600 font-Inter w-[85px] shrink-0">
                        Phone No
                      </span>
                      <input
                        type="text"
                        value={ReportData.mobileNo}
                        ref={pNoRef}
                        onChange={(e) =>
                          setReportData({
                            ...ReportData,
                            mobileNo: e.target.value,
                          })
                        }
                        disabled={userType === "CUSTOMERS"}
                        className="flex-1 border border-gray-300 rounded-[4px] h-7 px-2 text-[11px] text-slate-800 font-Inter focus:outline-none focus:border-[#1a3abf]"
                      />
                    </div>
                  )}
                </div>

                {/* Footer Buttons */}
                <div className="flex justify-center items-center gap-3 border-t border-gray-200 py-2.5 px-4 bg-[#f8faff] shrink-0">
                  <button
                    type="button"
                    onClick={openReportModal}
                    className="bg-[#2563eb] text-white hover:bg-blue-700 transition flex items-center justify-center py-1.5 px-7 rounded-[4px] shadow-sm font-semibold cursor-pointer text-xs font-Inter border-none active:scale-95"
                  >
                    Show
                  </button>
                  <button
                    type="button"
                    onClick={(e) => {
                      closeFindDialog(e);
                      handleClear();
                    }}
                    className="bg-white text-slate-700 hover:bg-gray-50 border border-gray-300 transition flex items-center justify-center py-1.5 px-7 rounded-[4px] shadow-sm font-semibold cursor-pointer text-xs font-Inter active:scale-95"
                  >
                    Exit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {showReportModal && (
        <div className="fixed inset-0 z-[10000] flex items-center justify-center bg-black/50 p-1 sm:p-2">
          <SchemeReport
            onClose={() => {
              setShowReportModal(false);
              setSchemeReportPayload(null);
              handleClear();
            }}
            reportData={schemeReportPayload?.reportData || ReportData}
            forms={schemeReportPayload?.forms || selectedForms}
          />
        </div>
      )}
      {showRecOptions && (
        <div
          className="fixed inset-0 flex items-center justify-center z-50 p-4"
          style={{ background: "rgba(0,0,20,0.55)", backdropFilter: "blur(6px)" }}
          onClick={() => setShowRecOptions(false)}
        >
          <div
            className="w-full max-w-sm rounded-2xl border border-white/20 p-5 shadow-2xl flex flex-col"
            style={{
              background: "linear-gradient(135deg, rgba(10,25,80,0.92) 0%, rgba(5,15,50,0.95) 100%)",
              backdropFilter: "blur(20px)",
              boxShadow: "0 8px 40px 0 rgba(0,0,80,0.45), 0 1.5px 0 0 rgba(255,255,255,0.08) inset",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-center justify-between pb-3 border-b border-white/10 mb-3">
              <div className="flex items-center gap-2">
                <div className="w-7 h-7 rounded-full bg-white/10 border border-white/20 flex items-center justify-center">
                  <div className="relative flex items-center justify-center">
                    <FiFile className="text-white text-sm" />
                    <span className="absolute text-[6px] font-bold text-white mt-[1px]">$</span>
                  </div>
                </div>
                <span className="text-white font-semibold text-[14px] tracking-wide font-Inter">
                  Select Receipt Form
                </span>
              </div>
              <button
                onClick={() => setShowRecOptions(false)}
                className="w-7 h-7 rounded-full bg-white/10 hover:bg-red-500/70 border border-white/20 flex items-center justify-center text-white/70 hover:text-white transition-all duration-200 text-xs font-bold"
              >
                ✕
              </button>
            </div>

            <div className="flex flex-col gap-2 max-h-[220px] overflow-y-auto">
              {formsByagent.map(([fId, abbreviation, typeOfVoucher], index) => (
                <button
                  key={index}
                  onClick={() => {
                    navigate("/receipt", {
                      state: { fId, abbreviation, typeOfVoucher },
                    });
                    closeRecOptions();
                  }}
                  className="w-full flex items-center gap-3 px-4 py-2.5 rounded-xl border border-white/15 bg-white/10 hover:bg-white/20 text-white text-[13px] font-medium tracking-wide transition-all duration-200 text-left font-Inter"
                >
                  <div className="w-7 h-7 rounded-full bg-blue-400/20 border border-blue-300/25 flex items-center justify-center shrink-0">
                    <div className="relative flex items-center justify-center">
                      <FiFile className="text-blue-200 text-xs" />
                      <span className="absolute text-[5px] font-bold text-blue-200 mt-[1px]">$</span>
                    </div>
                  </div>
                  <span className="flex-1 truncate">{abbreviation}</span>
                  <span className="text-white/40 text-xs">→</span>
                </button>
              ))}
            </div>
          </div>
        </div>
      )}

      {showRedeemOptions && (
        <div
          className="fixed inset-0 flex items-center justify-center z-50 p-4"
          style={{ background: "rgba(0,0,20,0.55)", backdropFilter: "blur(6px)" }}
          onClick={() => setShowRedeemOptions(false)}
        >
          <div
            className="w-full max-w-sm rounded-2xl border border-white/20 p-5 shadow-2xl flex flex-col"
            style={{
              background: "linear-gradient(135deg, rgba(10,25,80,0.92) 0%, rgba(5,15,50,0.95) 100%)",
              backdropFilter: "blur(20px)",
              boxShadow: "0 8px 40px 0 rgba(0,0,80,0.45), 0 1.5px 0 0 rgba(255,255,255,0.08) inset",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-center justify-between pb-3 border-b border-white/10 mb-3">
              <div className="flex items-center gap-2">
                <div className="w-7 h-7 rounded-full bg-white/10 border border-white/20 flex items-center justify-center">
                  <FiGift className="text-white text-sm" />
                </div>
                <span className="text-white font-semibold text-[14px] tracking-wide font-Inter">
                  Select Redeem Form
                </span>
              </div>
              <button
                onClick={() => setShowRedeemOptions(false)}
                className="w-7 h-7 rounded-full bg-white/10 hover:bg-red-500/70 border border-white/20 flex items-center justify-center text-white/70 hover:text-white transition-all duration-200 text-xs font-bold"
              >
                ✕
              </button>
            </div>

            <div className="flex flex-col gap-2 max-h-[220px] overflow-y-auto">
              {redeemFormsByagent.map(([fId, abbreviation, typeOfVoucher], index) => (
                <button
                  key={index}
                  onClick={() => {
                    navigate("/redeem", {
                      state: { fId, abbreviation, typeOfVoucher },
                    });
                    closeRedeemOptions();
                  }}
                  className="w-full flex items-center gap-3 px-4 py-2.5 rounded-xl border border-white/15 bg-white/10 hover:bg-white/20 text-white text-[13px] font-medium tracking-wide transition-all duration-200 text-left font-Inter"
                >
                  <div className="w-7 h-7 rounded-full bg-purple-400/20 border border-purple-300/25 flex items-center justify-center shrink-0">
                    <FiGift className="text-purple-200 text-xs" />
                  </div>
                  <span className="flex-1 truncate">{abbreviation}</span>
                  <span className="text-white/40 text-xs">→</span>
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default HomePageMob;
